import React from 'react';
import PropTypes from 'prop-types';
import MediaQueries from 'react-responsive';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import Image from 'marketing-website/components/modules/Image';
import MediaMultipleImages from 'marketing-website/components/modules/Media/MediaMultipleImages';
import ParallaxWrapper from 'marketing-website/components/wrappers/ParallaxWrapper';
import Pattern from 'marketing-website/components/commons/Pattern';
import RevealWrapper from 'marketing-website/components/wrappers/RevealWrapper';
import Shape from 'marketing-website/components/commons/Shape';

import assets from 'marketing-website/configs/pages/features/prototyping/assets.js';

export default function RealisticPrototypes({ color }) {
  return (
    <Spacing type="padding" size="xs" position="topBottom">
      <PageWrap size="l">
        <RevealWrapper>
          <Grid columns={12} alignItems="center">
            <GridItem columnSpan={12} columnSpanM={4}>
              <MediaQueries maxWidth={769}>
                <Spacing type="padding" size="l" position="bottom">
                  <Image {...assets.prototypeFallback} hasShadow={false} />
                </Spacing>
              </MediaQueries>
              <MaxWidth value={400}>
                <HeadingBlock
                  title="Create realistic prototypes, without code"
                  copy={
                    <span>
                      In less than 5 minutes, transform your design mockups into
                      interactive, online prototypes without writing a single
                      line of code.
                      <br />
                      <br />
                      Simply pull in screens made from Sketch, our design tool,
                      or upload your own images - and add hotspots, interactions
                      and layers as you wish.
                    </span>
                  }
                />
              </MaxWidth>
            </GridItem>
            <GridItem columnSpan={12} columnSpanM={8}>
              <MediaQueries minWidth={770}>
                <MediaMultipleImages
                  fallbackImageSrc={assets.prototypeFallback.src}
                  fallbackImageAlt={assets.prototypeFallback.alt}
                  fallbackImageMaxWidth={assets.prototypeFallback.maxWidth}
                >
                  <Shape
                    width={306}
                    height={296}
                    type="losange"
                    color="lightTeal"
                    center={false}
                    position="absolute"
                    bottom="22%"
                    left="30%"
                    top="auto"
                  />
                  <ParallaxWrapper speed={0}>
                    <Pattern
                      type="shortRectangle"
                      top="52%"
                      left="30%"
                      color={color}
                    />
                  </ParallaxWrapper>
                  <ParallaxWrapper speed={0.8}>
                    <Image
                      {...assets.chart}
                      borderRadius="m"
                      left="68%"
                      maxWidth={244}
                      position="absolute"
                      top="36%"
                    />
                  </ParallaxWrapper>
                  <ParallaxWrapper speed={1.2}>
                    <Image
                      {...assets.buttons}
                      borderRadius="m"
                      left="24%"
                      maxWidth={208}
                      position="absolute"
                      top="25%"
                    />
                  </ParallaxWrapper>
                  <ParallaxWrapper speed={2}>
                    <Image
                      {...assets.iPhone}
                      hasShadow={false}
                      maxWidth={263}
                      position="absolute"
                      top="auto"
                      left="42%"
                      bottom="25%"
                    />
                  </ParallaxWrapper>
                </MediaMultipleImages>
              </MediaQueries>
            </GridItem>
          </Grid>
        </RevealWrapper>
      </PageWrap>
    </Spacing>
  );
}

RealisticPrototypes.propTypes = {
  color: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/pages/features/prototyping/RealisticPrototypes.js